export const CUE_EDIT_WORKFLOW_CTA = {
  ctaId: 'workflows_edit_workflow_cta',
  viewEvent: 'workflows:cue_edit_workflow_button_view',
  clickEvent: 'workflows:cue_edit_workflow_button_click',
} as const;
